import { Endpoint } from '../endpoint';
import { CommonService } from '@business/services';
import {
  OrderEmailTemplateRequest,
  TMChangeOrdeRDepositCardRequest,
  TMChangeOrderDepositAchRequest,
  TMChangeOrderId,
  TMChangeOrderResponse,
} from '@business/entities/tm';
import { ChangeOrderFormData } from '@modules/timeMaterials/AddEditTMChangeOrderPage/TMChangeOrderForm';
import { R } from '@core/utils/r';

export function fetchChangeOrders(tmId: string, isCompact = false) {
  const params = R.objectCompact({ tmId, isCompact });
  return Endpoint.get<TMChangeOrderResponse[]>(`@gc/tm-change-order`, { params });
}

export function fetchChangeOrder(id: TMChangeOrderId) {
  return Endpoint.get<TMChangeOrderResponse>(`@gc/public/tm-change-order/change-order/${id}`);
}

export function createOrder(data: ChangeOrderFormData) {
  return Endpoint.post<TMChangeOrderResponse>(`@gc/tm-change-order`, { data });
}

export function sendCO(id: TMChangeOrderId, data: OrderEmailTemplateRequest) {
  return Endpoint.post<TMChangeOrderResponse>(`@gc/tm-change-order/send-co/${id}`, { data });
}

export function onSigned(id: TMChangeOrderId, sign: string) {
  return Endpoint.post<TMChangeOrderResponse>(`@gc/public/tm-change-order/on-signed/${id}`, { data: { sign } });
}

export function payWithACH(id: TMChangeOrderId, data: TMChangeOrderDepositAchRequest) {
  return Endpoint.post<TMChangeOrderResponse>(`@gc/tm-co-payment/ach/${id}`, { data });
}

export function payWithCard(id: TMChangeOrderId, data: TMChangeOrdeRDepositCardRequest) {
  return Endpoint.post<TMChangeOrderResponse>(`@gc/tm-co-payment/card/${id}`, { data });
}

export function deleteCO(id: TMChangeOrderId) {
  return Endpoint.delete(`@gc/tm-change-order/${id}`);
}

export function updateOrder(id: TMChangeOrderId, data: ChangeOrderFormData) {
  return Endpoint.patch<TMChangeOrderResponse>(`@gc/tm-change-order/${id}`, { data });
}

export function updateChangeOrderStatus(id: TMChangeOrderId, data: Partial<TMChangeOrderResponse>) {
  return Endpoint.patch<TMChangeOrderResponse>(`@gc/tm-change-order/update-status/${id}`, { data });
}

export function updateCOInvoice(id: TMChangeOrderId, data: Partial<TMChangeOrderResponse>) {
  return Endpoint.patch<TMChangeOrderResponse>(`@gc/tm-change-order/invoice/${id}`, { data });
}
